// src/components/TermsPage.jsx
import { usePageMeta } from "../utils/pageMeta";

export default function TermsPage({ onBack }) {
  usePageMeta({
    title: "이용약관",
    description: "펫말 이용약관 — 서비스 이용 조건과 책임의 범위를 안내합니다.",
    canonicalPath: "/terms",
  });
  const section = { marginBottom: 28 };
  const h2 = {
    fontFamily: "'Jua', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    color: "#5c3d2e",
    marginBottom: 10,
  };
  const p = {
    fontSize: 16,
    fontWeight: 400,
    color: "#6b5040",
    lineHeight: 2,
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "0 20px" }}>
      <button
        onClick={onBack}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          color: "#b09070", fontSize: 16, fontWeight: 400, cursor: "pointer",
          border: "none", background: "none",
          fontFamily: "'Gowun Batang', serif",
          padding: "8px 0", margin: "24px 0 20px",
        }}
      >
        ← 돌아가기
      </button>

      <div style={{
        background: "white",
        borderRadius: 24,
        padding: "36px 32px",
        boxShadow: "0 4px 24px rgba(92,61,46,0.07)",
        animation: "fadeUp .5s ease",
      }}>
        <div style={{
          fontFamily: "'Jua', sans-serif", fontSize: 24, fontWeight: 700,
          color: "#5c3d2e", marginBottom: 6,
        }}>
          이용약관
        </div>
        <div style={{ fontSize: 13, color: "#b09070", marginBottom: 28 }}>
          시행일: 2026년 4월 6일
        </div>

        <div style={section}>
          <div style={h2}>제1조 (목적)</div>
          <div style={p}>
            본 약관은 엔돌핀스튜디오(이하 "회사")가 운영하는 펫말(petmal.kr, 이하 "서비스")의
            이용에 관한 기본적인 사항을 규정함을 목적으로 합니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제2조 (정의)</div>
          <div style={p}>
            1. "서비스"란 회사가 petmal.kr을 통해 제공하는 AI 기반 반려동물 편지 생성 서비스를 말합니다.<br />
            2. "이용자"란 본 약관에 따라 서비스를 이용하는 모든 사람을 말합니다.<br />
            3. "콘텐츠"란 이용자가 입력한 정보와 AI가 생성한 편지 내용을 포함합니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제3조 (약관의 효력 및 변경)</div>
          <div style={p}>
            1. 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.<br />
            2. 회사는 관련 법령에 위배되지 않는 범위 내에서 약관을 변경할 수 있으며,
            변경 시 시행일 7일 전부터 서비스 내에 공지합니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제4조 (서비스의 내용)</div>
          <div style={p}>
            1. 펫말은 이용자가 입력한 반려동물 정보와 에피소드를 바탕으로
            AI가 반려동물의 시점에서 편지를 생성하는 서비스를 제공합니다.<br />
            2. 생성된 편지는 AI에 의해 자동으로 작성되며, 실제 반려동물의 의사와는 무관합니다.<br />
            3. 서비스는 무료로 제공되며, 광고가 포함될 수 있습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제5조 (이용자의 의무)</div>
          <div style={p}>
            이용자는 서비스 이용 시 다음 행위를 해서는 안 됩니다.<br /><br />
            1. 타인의 개인정보를 무단으로 수집하거나 도용하는 행위<br />
            2. 서비스를 영리 목적으로 무단 이용하는 행위<br />
            3. 서비스의 정상적인 운영을 방해하는 행위<br />
            4. 불법적이거나 부적절한 콘텐츠를 입력하는 행위<br />
            5. 서비스를 자동화된 수단(봇 등)으로 대량 이용하는 행위
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제6조 (지적재산권)</div>
          <div style={p}>
            1. 서비스의 디자인, 코드, 로고 등에 대한 지적재산권은 회사에 귀속됩니다.<br />
            2. AI가 생성한 편지 콘텐츠의 저작권은 관련 법령에 따릅니다.<br />
            3. 이용자가 입력한 에피소드와 정보에 대한 권리는 이용자에게 있습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제7조 (면책)</div>
          <div style={p}>
            1. AI가 생성한 편지 내용의 정확성, 적절성에 대해 회사는 보증하지 않습니다.<br />
            2. 서비스 이용으로 발생한 정서적 영향에 대해 회사는 책임을 지지 않습니다.<br />
            3. 천재지변, 서버 장애 등 불가항력으로 인한 서비스 중단에 대해 회사는 책임을 지지 않습니다.<br />
            4. 이용자의 기기 환경이나 네트워크 상태로 인한 서비스 이용 장애에 대해 회사는 책임을 지지 않습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제8조 (개인정보 보호)</div>
          <div style={p}>
            이용자의 개인정보 보호에 관한 사항은 별도의 개인정보처리방침에 따릅니다.
            자세한 내용은{" "}
            <a href="/privacy" style={{ color: "#c4845a", textDecoration: "underline" }}>
              개인정보처리방침
            </a>
            을 참고해주세요.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제9조 (서비스 변경 및 중단)</div>
          <div style={p}>
            1. 회사는 서비스의 내용을 변경하거나 중단할 수 있으며,
            중요한 변경 사항은 사전에 공지합니다.<br />
            2. 무료 서비스의 특성상, 서비스 중단에 대한 별도 보상은 제공하지 않습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>제10조 (분쟁 해결)</div>
          <div style={p}>
            본 약관과 관련하여 분쟁이 발생한 경우, 관련 법령에 따라 해결합니다.
            서비스 이용과 관련한 문의는 rnak24@gmail.com으로 연락해주세요.
          </div>
        </div>
      </div>

      <div style={{ height: 40 }} />
    </div>
  );
}
